import React, { useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import { pages } from 'common';
import { useNavigate } from 'react-router-dom-v5-compat';
import { useRedirect } from '../../contexts';

function ProtectedRoute({ user }) {
  const { setRedirect } = useRedirect();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    setRedirect(currentPath);
  }, [setRedirect]);

  let message;
  if (user && !user.isConfirmed) {
    message = 'Please confirm your email address to access this content.';
  } else if (user) {
    message = 'Please contact an administrator if you feel this is an error.';
  } else {
    message = 'Please Sign In to view this page.';
  }

  const handleSignIn = () => {
    navigate(pages.signIn.path);
  };

  return (
    <div className="flex flex-col items-center my-4 flex-1 justify-center">
      <Typography variant="h3" className="mb3">
        {message}
      </Typography>

      {!user && (
        <div className="flex flex-col">
          <Button variant="contained" color="primary" onClick={handleSignIn}>
            Sign In
          </Button>

          <p className="my-4">Don&apos;t have an account?</p>

          <Button
            variant="outlined"
            color="primary"
            onClick={() => navigate(pages.signUp.path)}
          >
            Sign up
          </Button>
        </div>
      )}
    </div>
  );
}

export default ProtectedRoute;
